let accordions = [...document.querySelectorAll('.vp-block-accordion')]
let group = 0
let started = false

// dispatch accordions in groups and open first item of group
for (const accordion of accordions) {
    if (!accordion.previousElementSibling?.classList.contains('vp-block-accordion')) {
        group++
        accordion.open = true
    }
    accordion.dataset.group = group

    accordion.addEventListener('toggle', (e) => {
        if (!started) return
        const target = e.target
        const open = !!target.open
        for (const el of accordions) {
            if (open && el.dataset.group == target.dataset.group && el !== target) {
                el.open = false
            }
        }
        if (open) {
            setTimeout(() => {
                target.scrollIntoView({
                    block: 'start',
                    inline: 'nearest',
                    behavior: 'smooth',
                })
            }, 50)
        }
    })
}

setTimeout(() => {
    started = true
}, 0)
